import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function GameCard(props) {
    const game_name = props.name;
    const game_id = props.id; 
    const navigate = useNavigate();
     
      return (
      <Card sx={{margin:"20px", flexGrow:1}} onClick={ ()=> navigate("/console/"+props.console_id+"/"+game_id)}>
        <CardActionArea>
          <CardContent>
            <Typography gutterBottom variant="h5" component="div" sx={{textAlign:"center"}}>
              {game_name}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    );
}
